import styled from '@emotion/styled';

export const Body3 = styled.p`
  font-family: Khula-Regular;
  color: ${(props) => props.color};
  font-size: 16px;
  line-height: 25px;
`;
